import { useEffect } from "react"
import { redirect, useLocation, useNavigate } from "react-router-dom"

export default function Home() {
    const location = useLocation();
    const navigate = useNavigate()
    useEffect(() => {
        if (window.location.pathname === location.pathname) {
            navigate("/login");
            return
        }
    },[])
    return (
        <div className="text-3xl font-medium">Home... </div>
    )
}